import { Text, Tooltip } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import * as Styled from './voidStaticActionButtonStyle'

interface VoidStaticActionButtonProps {
  isSyncedWithCPA: boolean
  toolTipMessage?: string
}

export const VoidStaticActionButton = ({ isSyncedWithCPA, toolTipMessage }: VoidStaticActionButtonProps) => {
  const { t } = useTranslation()

  if (!isSyncedWithCPA) {
    return <Text>{t('bills.table.static_actions.void')}</Text>
  }

  return (
    <Styled.TooltipWrapper>
      <Tooltip label={toolTipMessage} placement="bottom">
        <Text>{t('bills.table.static_actions.void')}</Text>
      </Tooltip>
    </Styled.TooltipWrapper>
  )
}
